/**
 * `AlertCard` (`19-composants-frontend.md`) : type, ancienneté, statut de cycle de vie, et l'action
 * de clôture selon les droits — `PATCH /v1/alertes/{id}` est réservé aux profils TotalEnergies
 * (Air Tahiti et Support consultent, ils ne traitent pas).
 */
import { Link } from "react-router-dom";

import type { Alerte } from "../../shared/api/types";
import { formaterDate, ilYA } from "../../shared/composants/formatage";

export const LIBELLE_TYPE: Record<string, string> = {
  batterie_faible: "Batterie faible",
  tracker_silencieux: "Tracker silencieux",
  sortie_de_zone: "Sortie de zone",
  duree_anormale_escale: "Durée anormale sur escale",
  anomalie_de_suivi: "Anomalie de suivi",
  epreuve_etancheite_rappel: "Rappel d'épreuve d'étanchéité",
  epreuve_etancheite_retard: "Épreuve d'étanchéité en retard",
  document_echeance: "Document arrivant à échéance",
};

export function AlertCard({
  alerte,
  peutTraiter,
  enCoursDeCloture,
  cloturer,
}: {
  alerte: Alerte;
  peutTraiter: boolean;
  enCoursDeCloture: boolean;
  cloturer: () => void;
}) {
  // `priorite` est calculée et persistée côté serveur (`docs/DECISIONS.md` D79), plus recalculée à
  // l'affichage : ce qui la fait changer (relance, escalade) reste dans `alertes/service.py`.
  const escaladee = alerte.date_escalade != null;

  return (
    <article
      className={`carte-alerte carte-alerte--${alerte.statut} carte-alerte--${alerte.priorite}`}
    >
      <header className="carte-alerte__entete">
        <span className="carte-alerte__type">
          {LIBELLE_TYPE[alerte.type_alerte] ?? alerte.type_alerte}
        </span>
        {escaladee && <span className="badge badge--alerte">Escaladée</span>}
        {!escaladee && alerte.nombre_relances > 0 && (
          <span className="badge">{alerte.nombre_relances} relance(s)</span>
        )}
        <Link to={`/grv/${encodeURIComponent(alerte.numero_grv)}`} className="carte-alerte__grv">
          {alerte.numero_grv}
        </Link>
      </header>
      <p>{alerte.message}</p>
      <p className="carte-alerte__meta">
        Ouverte {ilYA(alerte.date_ouverture)} ({formaterDate(alerte.date_ouverture)})
      </p>
      {alerte.statut === "close" && alerte.date_cloture && (
        <p className="carte-alerte__meta">
          Clôturée {ilYA(alerte.date_cloture)}
          {alerte.motif_cloture === "condition_levee" ? " (condition levée)" : ""}
          {alerte.cloture_par ? ` par ${alerte.cloture_par}` : ""}
        </p>
      )}
      {peutTraiter && alerte.statut !== "close" && (
        <div className="formulaire-actions">
          <button type="button" onClick={cloturer} disabled={enCoursDeCloture}>
            Clôturer
          </button>
        </div>
      )}
    </article>
  );
}
